module.exports = "/_next/static/images/QueryData-1@2x-114ccdde77f1ee23e7731ff2537e94fc.png";